import { useState } from "react";
// Import Swiper React components
import {
  EffectFade,
  Autoplay,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/scss";
import "swiper/scss/effect-fade";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import { addDefaultImg } from "./imageUtils";

const Testimonials = () => {

      const [slidesPerView, setSlidesPerView] = useState(1);


  return (
    <>
      <div className="container-fluid bg-theme-primary m-0 py-4 py-md-5">
        <div className="container text-theme-light">
          <div className="section-header text-left mx-auto mb-5 ">
            <h1 className="section-heading text-theme-light">
              Customer Reviews
            </h1>
            {/* <p>
              Tempor ut dolore lorem kasd vero ipsum sit eirmod sit. Ipsum diam
              justo sed rebum vero dolor duo.
            </p> */}
          </div>

          <div className="container-fluid p-0 wow fadeIn testimonials">
            <Swiper
              modules={[
                EffectFade,
                Autoplay,
                Pagination,
                Scrollbar,
                A11y,
              ]}
              spaceBetween={10}
              slidesPerView={slidesPerView}
              breakpoints={{
                540: { slidesPerView: 1.1 },
                768: { slidesPerView: 2.1 },
                1024: { slidesPerView: 3.1 },
            }}
              style={{ display: 'flex' }}
              loop
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              onSwiper={(swiper) => console.log(swiper)}
            >
              <SwiperSlide>
                <div className="swiperItem">
                  <div className="testimonial-item position-relative bg-white p-4 rounded">
                    <p className="mb-4 text-primary">
                      I would highly recommend these products to anyone who is looking for high-quality essential oils that deliver real benefits.
                    </p>
                    <div className="d-flex align-items-center">
                      <img
                        className="flex-shrink-0 rounded-circle"
                        src="../assets/images/lucas.png"
                        alt=""
                        onError={addDefaultImg}
                      />
                      <div className="ms-3">
                        <h5 className="mb-1 text-primary">Lucas (UK)</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="swiperItem">
                  <div className="testimonial-item position-relative bg-white p-4 rounded">
                    <p className="mb-4 text-primary">
                      The Liquid extracts available with them are really very effective and trustable. They are regularly supplying us the consistent quality for our brand.
                    </p>
                    <div className="d-flex align-items-center">
                      <img
                        className="flex-shrink-0 rounded-circle"
                        src="../assets/images/laura.png"
                        alt=""
                        onError={addDefaultImg}
                      />
                      <div className="ms-3">
                        <h5 className="mb-1 text-primary">Laura (France)</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="swiperItem">
                  <div className="testimonial-item position-relative bg-white p-4 rounded">
                    <p className="mb-4 text-primary">
                      Deww Botanicals offers highly competitive crude oil pricing that balances quality and market conditions, providing excellent value for money. If you’re looking for cost-effective solutions without sacrificing quality, they are an excellent choice.
                    </p>
                    <div className="d-flex align-items-center">
                      <img
                        className="flex-shrink-0 rounded-circle"
                        src="../assets/images/krishna.png"
                        alt=""
                        onError={addDefaultImg}
                      />
                      <div className="ms-3">
                        <h5 className="mb-1 text-primary">Stephen (Canada)</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="swiperItem">
                  <div className="testimonial-item position-relative bg-white p-4 rounded">
                    <p className="mb-4 text-primary">
                      Personally used their essential oils !!
Quality of product is really good and smell is long lasting.
Definitely recommend this product to everyone.
                    </p>
                    <div className="d-flex align-items-center">
                      <img
                        className="flex-shrink-0 rounded-circle"
                        src="../assets/images/shabina.jpg"
                        alt=""
                        onError={addDefaultImg}
                      />
                      <div className="ms-3">
                        <h5 className="mb-1 text-primary">Shabina Raza (UAE)</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="swiperItem">
                  <div className="testimonial-item position-relative bg-white p-4 rounded">
                    <p className="mb-4 text-primary">
                      Very happy to deal with this company. They provided me good services. Products are also upto the mark.
                    </p>
                    <div className="d-flex align-items-center">
                      <img
                        className="flex-shrink-0 rounded-circle"
                        src="../assets/images/emily.jpg"
                        alt=""
                        onError={addDefaultImg}
                      />
                      <div className="ms-3">
                        <h5 className="mb-1 text-primary">Emily (UK)</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </>
  );
};

export default Testimonials;
